function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M234.549 42.2227H21.549C10.245 42.2227 1.04895 51.4187 1.04895 62.7227V184.281C1.04895 195.585 10.245 204.781 21.549 204.781H234.549C245.853 204.781 255.049 195.585 255.049 184.281V62.7227C255.049 51.4187 245.853 42.2227 234.549 42.2227ZM231.295 53.2227L128.05 121.655L24.802 53.2227H231.295ZM244.049 184.281C244.049 189.519 239.787 193.781 234.549 193.781H21.549C16.311 193.781 12.049 189.519 12.049 184.281V62.7227C12.049 61.2437 12.3991 59.8487 13.0031 58.5997L123.343 131.732C124.728 132.651 126.389 133.111 128.05 133.111C129.71 133.111 131.37 132.652 132.755 131.733L243.094 58.5997C243.699 59.8487 244.049 61.2446 244.049 62.7236V184.281Z",
  fill: "black"
});

function SvgIconMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 257 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.1e911e7cc50a5cb606bd2c1a44c857b4.svg";
export { ForwardRef as ReactComponent };